export const FIREHOUSE_INSIDERS_PROGRAM_NAME = 'Firehouse Subs Insiders';

/** TODO: update href once we have the static page. */
export const FIREHOUSE_INSIDERS_INFO_URL = '/';

export const FIREHOUSE_INSIDERS_ARIA_LABEL = `I want to join ${FIREHOUSE_INSIDERS_PROGRAM_NAME} and consent to receiving occasional invites to surveys or focus groups.`;
